import createIcon from '../../createIcon';

/**
 * @component @name AirlineSeatLegroomExtra
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMy41IDEyVjNIMS41VjEyQzEuNSAxNC43NiAzLjc0IDE3IDYuNSAxN0gxMi41VjE1SDYuNUM0Ljg0IDE1IDMuNSAxMy42NiAzLjUgMTJaTTIyLjMzIDE3LjI0QzIxLjk1IDE2LjUyIDIxLjA0IDE2LjI3IDIwLjMgMTYuNjFMMTkuMjEgMTcuMTFMMTUuOCAxMC4xM0MxNS40NiA5LjQ1IDE0Ljc3IDkuMDEgMTQuMDEgOS4wMUwxMC41IDlWM0g0LjVWMTFDNC41IDEyLjY2IDUuODQgMTQgNy41IDE0SDE0LjVMMTcuOTEgMjFMMjEuNjMgMTkuM0MyMi40IDE4Ljk0IDIyLjczIDE4IDIyLjMzIDE3LjI0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AirlineSeatLegroomExtra = createIcon('AirlineSeatLegroomExtra', [
  [
    'path',
    {
      d: 'M3.5 12V3H1.5V12C1.5 14.76 3.74 17 6.5 17H12.5V15H6.5C4.84 15 3.5 13.66 3.5 12ZM22.33 17.24C21.95 16.52 21.04 16.27 20.3 16.61L19.21 17.11L15.8 10.13C15.46 9.45 14.77 9.01 14.01 9.01L10.5 9V3H4.5V11C4.5 12.66 5.84 14 7.5 14H14.5L17.91 21L21.63 19.3C22.4 18.94 22.73 18 22.33 17.24Z',
      key: '1mtktw',
    },
  ],
]);

export default AirlineSeatLegroomExtra;
